.map-legend-container-hidden {
  display: none !important;
}

.map-legend-container {
  left: 0.5rem;
  bottom: 2.8rem;
  display: flex;
  flex-direction: column;
  position: absolute;
  overflow: visible;
  pointer-events: all;
  max-width: 80%;
  max-height: 65%;

  box-sizing: border-box;
  background: transparent;

  .content-container {
    display: flex;
    flex-direction: row;
    height: 100%;
    width: 100%;
    border: 1px solid #ccc;
    user-select: none;

    &:hover .controls-map-legend span {
      visibility: visible;
      cursor: pointer;
      color: #ccc;

      &:hover {
        color: black;
      }
    }
  }

  .element {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    width: 100%;
    border-right: 1px solid #ccc;
  }

  .controls-map-legend {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 4px 8px 2px 2px;
    background-color: rgba(249, 251, 251, 0.8);
    box-sizing: border-box;
    height: 40px;
    container-type: inline-size;

    & .parameter-text {
      font-size: 10cqw;
      flex: 1;
      max-width: 90%;
      overflow: hidden;
      // white-space: nowrap;
      text-overflow: ellipsis;
      cursor: default;
    }

    & span {
      font-size: 1rem;
      visibility: hidden;
    }
  }

  .map-legend-wrapper {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    height: calc(100% - 25px);
    width: 100%;
    box-sizing: border-box;
  }


  .resize-handle {
    position: absolute;
    width: 16px;
    height: 16px;
    top: -1px;
    right: -2px;
    cursor: nesw-resize;
    background: url("../../../style/img/resize-icon.svg") no-repeat center;
    background-size: 8px 8px;
    touch-action: none;
    user-select: none;

    &--dragging {
      cursor: nesw-resize;
    }
  }
}

.bottom-legend {
  bottom: 6rem;
}

.top-legend {
  max-height: 55%;
}


.map-legends-toggle-button {
  width: 32px;
  height: 32px !important;
  border-radius: 16px;
  position: absolute;
  bottom: 0.5rem;
  left: 0.5rem;

  display: flex;
  align-items: center;
  justify-content: center;

  border: 1px solid var(--color-gray-200);
  box-shadow: -2px 4px 5px 0px rgba(0, 0, 0, 0.05);
  cursor: pointer;
}

.bottom-button {
  bottom: 3.8rem;
}

.toggle-button--hidden {
  visibility: hidden;
}
